<template>
  <b-modal id="giftCardPurchasesModal" title="Gift Card Purchases" size="lg"
    scrollable @shown="loadGiftCardPurchases" @hidden="clearGiftCardPurchases">

    <div class="col-md-12" ref="purchasesContainer">
      <div v-if="purchases.length === 0">
        <div class="alert alert-info" align="center">
          <br/>
          <strong>
            {{purchasesLoading ? 'Loading...': 'No purchases available...'}}
          </strong>
          <br/><br/>
        </div>
      </div>

      <div v-else>
        <b-button class="btn btn-sm" id="popover-target-1">
          Purchase Status List
        </b-button>
        <b-popover target="popover-target-1" triggers="hover"
          placement="right">
          <div class="row">
            <div class="col-md-12">
              <i class="fa fa-cog"></i> &nbsp; In process
            </div>
            <div class="col-md-12">
              <i class="fa fa-check-square-o"></i> &nbsp; Processed
            </div>
            <div class="col-md-12">
              <i class="fa fa-times-circle-o"></i> &nbsp; Payment failed
            </div>
            <div class="col-md-12">
              <i class="fa fa-undo"></i> &nbsp; Request Refund
            </div>
            <div class="col-md-12">
              <i class="fa fa-refresh"></i> &nbsp; Refunded
            </div>
            <div class="col-md-12">
              <i class="fa fa-exclamation-triangle"></i> &nbsp; Failed refund
            </div>
          </div>
        </b-popover>

        <b-button class="btn btn-sm btn-primary float-right" @click="exportPurchasesToCSVFile()">
          Export to CSV
        </b-button>
        <br/><br/>

        <div class="form-group">
          <input type="text" class="form-control" v-model="filterPurchaseByEmailOrderNumber"
            placeholder="Filter by Order Number or Email">
        </div>

        <table class="table">
          <thead>
            <tr>
              <th scope="col">Order No.</th>
              <th scope="col">Email</th>
              <th scope="col">Amount</th>
              <th scope="col" class="text-center">Status</th>
              <th scope="col" class="text-center">
                <i class="fa fa-calendar" aria-hidden="true"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(purchase, index) in this.filteredPurchases" :key="index">
              <td :id="'full-order-number-' + index">
                <a href="javascript:;">
                  {{ purchase.order_number.slice(-7) }}
                </a>
                <b-popover :target="'full-order-number-' + index" triggers="hover"
                  placement="top">
                  {{ purchase.order_number }}
                </b-popover>
              </td>
              <td> {{ purchase.user.email }} </td>
              <td> {{ purchase.formatted_amount }} </td>
              <td class="text-center">
                <PurchaseStatus
                  :status="purchase.status"
                />
              </td>
              <td class="text-center">
                {{ purchase.purchase_date }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template slot="modal-footer" slot-scope="{ ok, cancel }">
      <b-button variant="secondary" @click="hideModal">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import GiftCardService from '../../../services/GiftCardService'
import PurchaseStatus from '../../common/PurchaseStatus'

export default {
  name: 'GiftCardPurchasesModal',
  components: {
    PurchaseStatus
  },
  props: {
    giftCardId: {
      type: Number
    }
  },
  data: () => {
    return {
      purchasesLoading: true,
      purchases: [],
      filterPurchaseByEmailOrderNumber: ''
    }
  },
  computed: {
    filteredPurchases () {
      var self = this

      if (this.filterPurchaseByEmailOrderNumber) {
        return this.purchases.filter((purchase) => {
          return purchase.user.email.match(self.filterPurchaseByEmailOrderNumber) ||
            purchase.order_number.match(self.filterPurchaseByEmailOrderNumber)
        })
      } else {
        return this.purchases
      }
    }
  },
  methods: {
    loadGiftCardPurchases () {
      this.purchasesLoading = true
      var self = this
      var loader = this.$loading.show({
        container: this.$refs.purchasesContainer
      })

      GiftCardService.getPurchases().then((response) => {
        self.purchases = response.data
      }).finally(() => {
        self.purchasesLoading = false
        loader.hide()
      })
    },
    clearGiftCardPurchases () {
      this.purchases = []
    },
    hideModal () {
      this.$bvModal.hide('giftCardPurchasesModal')
    },
    exportPurchasesToCSVFile () {
      var self = this
      var headersCSV = {
        'order_number': 'Order Number',
        'user_name': 'Name',
        'user_email': 'Email',
        'formatted_amount': 'Amo',
        'status': 'Status',
        'purchased_at': 'Purchased At'
      }

      // Convert Object to JSON
      var headers = JSON.stringify([headersCSV])
      var purchasesList = this.purchases.map((purchase) => {
        return {
          'order_number': purchase.order_number,
          'user_name': `${purchase.user.first_name} ${purchase.user.last_name}`,
          'user_email': purchase.user.email,
          'formatted_amount': purchase.formatted_amount,
          'status': purchase.status,
          'purchased_at': self.moment(purchase.purchased_at).format('MM/DD/YY HH:mm')
        }
      })

      this.exportPurchasesLink(purchasesList, headers, 'gift-card-purchases.csv')
    }
  }
}
</script>
